import React from 'react';
import Aboutdtls from '../Components/Aboutdtls';
import VisionMission from '../Components/VisionMission';
import Financeproduct from '../Components/Financeproduct';
import CustomProduct from '../Components/CustomProduct';
import ClientCount from '../Components/ClientCount';
import ValuedClient from '../Components/ValuedClient';
import TestimonialsCarousel from '../Components/TestimonialsCarousel';
import SEO from "../Components/SEO";
import HeroSection from '../Components/HeroSection';
import SchoolProdHome from '../Components/SchoolProdHome';
import EcommerceProdHome from '../Components/EcommerceProdHome';
import GoogleReviews from '../Components/GoogleReviews';

export default function Home() {
  return (
    <>

    <SEO
        title="Software Development Company in Pune | School ERP & Finance Solutions | Uiplus Technologies"
        description="Uiplus Technologies is a software development company established in 2025 providing School ERP, Finance Management, Loan Billing Systems, and custom web application development in Pune, India."
        keywords="Software Company in Pune, School ERP Software, Finance Management Software, Loan Billing System, Custom Software Development, Web Application Development"
        url="https://uiplus.in/"
      />

      
      {/* ✅ HERO SECTION (Main Banner) */}
      <HeroSection />

      {/* ✅ ABOUT SECTION */}
      <section className="py-5">
        <Aboutdtls />
      </section>

      {/* ✅ VISION & MISSION */}
      <section className="py-5">
        <VisionMission />
      </section>


      {/* ✅ PRODUCTS / SERVICES */}
      <section className="py-5 bg-light">
        <SchoolProdHome />
        <Financeproduct />
        <EcommerceProdHome />
        <CustomProduct />
        
      </section>

      {/* ✅ CLIENT STATS */}
      <section className="py-5 bg-light">
        <GoogleReviews />
      </section>

      {/* ✅ CLIENT STATS */}
      <section className="py-5 bg-light">
        <ClientCount />
      </section>

      {/* ✅ VALUED CLIENTS */}
      <section className="py-5">
        <ValuedClient />
      </section>

      {/* ✅ TESTIMONIALS */}
      <section className="py-5 bg-light">
        <TestimonialsCarousel />
      </section>

    </>
  );
}
